import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiGet } from '../utils/api';
import { BsBell } from 'react-icons/bs';
import styles from './DashboardPage.module.css';

const DashboardPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [friendRequests, setFriendRequests] = useState([]);
  const [hasPendingRequests, setHasPendingRequests] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFriendRequests = async () => {
      try {
        setLoading(true);
        const response = await apiGet('/friendships/requests');
        
        if (response.ok) {
          const requests = await response.json();
          setFriendRequests(requests);
          setHasPendingRequests(requests.length > 0);
        } else {
          console.error('Failed to fetch friend requests');
        }
      } catch (error) {
        console.error('Error fetching friend requests:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFriendRequests();
  }, []);

  const handleBellClick = () => {
    navigate('/friend-requests');
  };

  return (
    <div className={styles.dashboardPage}>
      <header className={styles.dashboardHeader}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            <h1>Welcome back, {user?.name || 'User'}!</h1>
            <p>Here's what's happening with your podcasts</p>
          </div>
          <div className={styles.headerActions}>
            <button 
              className={`${styles.bellButton} ${hasPendingRequests ? styles.bellButtonActive : ''}`}
              onClick={handleBellClick}
              title={hasPendingRequests ? `${friendRequests.length} friend request${friendRequests.length !== 1 ? 's' : ''} pending` : 'No friend requests'}
            >
              <BsBell className={styles.bellIcon} />
              {hasPendingRequests && (
                <span className={styles.notificationBadge}>{friendRequests.length}</span>
              )}
            </button>
            <button 
              className={`btn btn-primary ${styles.createButton}`}
              onClick={() => navigate('/create-podcast')}
            >
              <strong>Create Podcast</strong>
            </button>
          </div>
        </div>
      </header>
      
      <div className={styles.dashboardGrid}>
        <div className={styles.dashboardCard}>
          <h3>Your Podcasts</h3>
          <p>Find your next listen.</p>
          <Link to="/podcasts" className={`btn btn-secondary ${styles.cardButton}`}>
            View All Podcasts
          </Link>
        </div>
        
        <div className={styles.dashboardCard}>
          <h3>Friends Activity</h3>
          <p>See what your friends are listening to.</p>
          <Link to="/friends" className={`btn btn-secondary ${styles.cardButton}`}>
            View Friends
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
